import React from 'react';
import PropTypes from 'prop-types';

import { ProjectDatabaseMemberPropTypes } from './prop_types';
import UserIconList from 'components/user_icon_list';
import ProjectCollaboratorModal from './project_collaborator_modal';

export default class CollaboratorHeader extends React.Component {
  static propTypes = {
    collaborators: PropTypes.arrayOf(ProjectDatabaseMemberPropTypes).isRequired,
    onCollaboratorsUpdated: PropTypes.func,
    onUpdateNotificationsBlockedUserIds: PropTypes.func
  }

  state = {
    showCollaboratorSelectionModal: false
  }

  showCollaboratorSelectModal = () => {
    this.setState({ showCollaboratorSelectionModal: true });
  }

  hideUserSelect = () => {
    this.setState({ showCollaboratorSelectionModal: false });
  }

  render() {
    const onAddFunc = this.props.onCollaboratorsUpdated ? this.showCollaboratorSelectModal : null;

    return (
      <React.Fragment>
        <UserIconList size="lg" users={this.props.collaborators} onAddClicked={onAddFunc} />
        {this.props.onCollaboratorsUpdated &&
          <ProjectCollaboratorModal
            modalTitle="Manage Users on this Listing"
            projectUsers={this.props.collaborators}
            show={this.state.showCollaboratorSelectionModal}
            onDone={this.hideUserSelect}
            onUpdateCollaborators={this.props.onCollaboratorsUpdated}
            onUpdateNotificationsBlockedUserIds={this.props.onUpdateNotificationsBlockedUserIds}
          />
        }
      </React.Fragment>
    );
  }
}
